var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accord", class: { closed: _vm.isClosed } }, [
    _c("header", { on: { click: _vm.onToggle } }, [
      _vm.link
        ? _c(
            "a",
            {
              attrs: { href: _vm.link, "data-id": "link" + _vm.linkName },
              on: {
                click: function ($event) {
                  return _vm.onAnchorClick($event)
                },
              },
            },
            [_vm._v(_vm._s(_vm.linkName))]
          )
        : _vm._e(),
      _vm._v(_vm._s(_vm.title)),
      _c("span", { attrs: { title: "open / close" } }),
    ]),
    _vm._v(" "),
    !_vm.isClosed ? _c("article", [_vm._t("default")], 2) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }